export const LandingServiceID = {
  RootStore: Symbol.for("LandingRootStore"),
  SessionStore: Symbol.for("LandingSessionStore"),
  Timer: Symbol.for("LandingTimer"),
};
